export const RedirectToParam = 'redirectTo';
